import { useMemo } from 'react'

import { useBattlePassState, useUserBankStars, useUserState } from '@store'

export const useUserProgress = () => {
  const user = useUserState()
  const bp = useBattlePassState()
  const stars = useUserBankStars()

  return useMemo(() => {
    if (bp && user?.battlepassLevel !== undefined && stars !== null) {
      const currentLevel = user.battlepassLevel

      const currentLevelInfo =
        currentLevel === 0
          ? { level: 0, stars: 0 }
          : bp.levels.find((item) => item.level === currentLevel)

      const nextLevelInfo = bp.levels.find(
        (item) => item.level === currentLevel + 1
      )

      if (!currentLevelInfo || !nextLevelInfo) {
        return 0
      }

      const prevStars = currentLevelInfo.stars
      const nextStars = nextLevelInfo.stars

      return Math.min(
        Math.max((stars - prevStars) / (nextStars - prevStars), 0),
        1
      )
    }

    return 0
  }, [bp, user?.battlepassLevel, stars])
}
